"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onBuyTicket = (eventId, title, productionReference, component, type) => {
    gtag('event', 'select_cntent', {
        "content_type": "product",
        "items": [
            {
                "id": eventId,
                "name": title,
                "brand": productionReference,
                "list_name": component,
                "category": type,
                "list_position": 1 //todo: remove?
            }
        ]
    });
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-google-analytics/src/tag.ts